<div class="row">
  <div class="col-12 col-md-6">
    <div class="questions-div" *ngIf="service !== null">
      <div *ngIf="questions.length > 0 && questions === service.modelClass.model['questionnaireQuestions']">
        <div class="card card-question" *ngFor="let q of questions">
          <div class="card-body">
            <div class="row">
              <div class="col-9 col-md-10" (click)="openQuestion(q)">
                <p class="question-txt">{{ q.txtQuestion }}</p>
                <p class="question-type"><b>Tipo: </b>{{ q.questionType?.type }}</p>
              </div>
              <div class="col-3 col-md-2 div-img-btn">
                <mat-icon (click)="openFormUpdate(q)" class="material-icons">edit</mat-icon>
                <mat-icon (click)="deleteQuestion(q)" class="material-icons">delete</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card card-question add" (click)="openFormQuestion()">
        <div class="card-body">
          <div class="row">
            <div class="col-9 col-md-10">
              <p class="question-txt ">{{ createBtnQuestion | translatePipe }}</p>
            </div>
            <div class="col-3 col-md-2 div-img-btn">
              <mat-icon class="material-icons">add_circle</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- div class="popup" *ngIf="questionSelected !== null">
      <div class="card card-questionnaire-question">
        <div class="card-header">
          <h1 class="card-title">{{ 'Pregunta o nombre de campo' }}</h1>
          <button type="button" class="close" (click)="closeQuestionModal()">X</button>
        </div>
        <div class="card-body">
          <p class="question">{{ questionSelected.txtQuestion }}</p>
          <div class="question-choices"
               *ngIf="questionSelected.questionType?.type === 'choice' || questionSelected.questionType?.type === 'multiple-choice'">
            <p class="question-choice {{ choice.isCorrectChoise ? 'correct' : '' }}"
               *ngFor="let choice of questionSelected.questionnaireQuestionChoises">{{ choice.txtChoise }}</p>
          </div>
          <div class="question-text" *ngIf="questionSelected.questionType?.type === 'ranking'">
            <input type="text">
          </div>
          <div class="question-text" *ngIf="questionSelected.questionType?.type === 'text'">
            <input type="text">
          </div>
        </div>
        <div class="card-footer">
          <div class="text-right">
            <button type="button" class="btn-xpert btn-bg-light mr-2" (click)="closeQuestionModal()">{{ 'commons.close'
              | translatePipe }}</button>
          </div>
        </div>
      </div>
    </div-->
  </div>
  <div class="col-12 col-md-6">
    <div *ngIf="createQuestion !== null">
      <div class="card-questionnaire-question-form">
        <form (ngSubmit)="addQuestion()" ngNativeValidate>
          <div class="card-body">
            <h1 class="card-title">{{ 'Agregar campo al formulario' }}</h1>
            <div class="row">
              <mat-form-field class="my-input-div col-12" appearance="fill">
                <div class="my-input">
                  <label>Pregunta o nombre de campo</label>
                  <textarea matInput [(ngModel)]="createQuestion.txtQuestion" name="{{ 'txtQuestion' }}" [required]="true" (keypress)="check($event)"></textarea>
                </div>
              </mat-form-field>

              <div class="onsight-form-input-select">
                <label>Tipo de pregunta o campo</label>
                <mat-form-field appearance="fill">
                  <mat-select class="form-control" placeholder="{{ 'commons.forms.select' | translatePipe }}"
                              [(ngModel)]="createQuestion.questionTypeID" name="questionTypeID" [required]="true">
                    <mat-option [value]="" [disabled]="true">{{ 'commons.forms.select' | translatePipe }}</mat-option>
                    <mat-option [value]="qt.questionTypeID" *ngFor="let qt of questionTypes">{{ 'commons.forms.selected.' + qt.type | translatePipe }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="onsight-form-input-select">
                <label>Tipo de resppuesta</label>
                <mat-form-field appearance="fill">
                  <mat-select class="form-control" placeholder="{{ 'commons.forms.select' | translatePipe }}"
                              [(ngModel)]="createQuestion.questionnaireAnswerType" name="{{ 'questionnaireAnswerType' }}" [required]="true">
                    <div class="select-options-div" *ngIf="createQuestion.questionTypeID === 1 || createQuestion.questionTypeID === 2">
                      <mat-option [value]="" [disabled]="true">{{ 'commons.forms.select' | translatePipe }}</mat-option>
                      <mat-option [value]="'String'">{{ 'commons.forms.response-type.' + 'String' | translatePipe }}</mat-option>
                    </div>
                    <div class="select-options-div" *ngIf="createQuestion.questionTypeID === 3 || createQuestion.questionTypeID === 4">
                      <mat-option [value]="" [disabled]="true">{{ 'commons.forms.select' | translatePipe }}</mat-option>
                      <mat-option [value]="'Int'">{{ 'commons.forms.response-type.' + 'Int' | translatePipe }}</mat-option>
                    </div>
                    <div class="select-options-div" *ngIf="createQuestion.questionTypeID === 5">
                      <mat-option [value]="" [disabled]="true">{{ 'commons.forms.select' | translatePipe }}</mat-option>
                      <mat-option [value]="'String'">{{ 'commons.forms.response-type.' + 'String' | translatePipe }}</mat-option>
                      <mat-option [value]="'Boolean'">{{ 'commons.forms.response-type.' + 'Boolean' | translatePipe }}</mat-option>
                      <mat-option [value]="'DateTime'">{{ 'commons.forms.response-type.' + 'DateTime' | translatePipe }}</mat-option>
                      <mat-option [value]="'Int'">{{ 'commons.forms.response-type.' + 'Int' | translatePipe }}</mat-option>
                      <mat-option [value]="'Decimal'">{{ 'commons.forms.response-type.' + 'Decimal' | translatePipe }}</mat-option>
                      <mat-option [value]="'Image'">{{ 'commons.forms.response-type.' + 'Image' | translatePipe }}</mat-option>
                      <mat-option [value]="'File'">{{ 'commons.forms.response-type.' + 'File' | translatePipe }}</mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              </div>

              <div *ngIf="createQuestion.questionTypeID === 1 || createQuestion.questionTypeID === 2 && showFormChoices" class="div-choices">
                <div class="col-12">
                  <div class="row title-tab-choices">
                    <h1 class="choices-table-title col-11">Respuesta</h1>
                    <!-- <h1 class="choices-table-title text-center col-2">Verdadera(s)</h1> -->
                    <h1 class="choices-table-title col-1"></h1>
                  </div>
                </div>
                <div *ngFor="let choice of createQuestion.questionnaireQuestionChoises; let i = index" class="col-12">
                  <div class="row form-choice">
                    <div class="col-11">
                      <input [value]="choice.txtChoise" [(ngModel)]="choice.txtChoise" name="{{ 'txtChoise' + choice.questionnaireQuestionChoiseID }}" (keyup)="setValue(choice, $event, i)" type="text" class="choice-answer-input">
                    </div>
                    <!-- <div class="col-2">
                      <input [(ngModel)]="choice.isCorrectChoise" type="checkbox"
                        name="{{ 'correctAnswers' + choice.questionnaireQuestionChoiseID }}"
                        (ngModelChange)="selectCorrectChoice(choice)" class="choice-answer-input">
                    </div> -->
                    <div class="col-1" (click)="deleteChoice(choice)"><mat-icon class="material-icons">delete</mat-icon></div>
                  </div>
                </div>
                <div class="btn-img" (click)="addChoiceToQuestion()"><mat-icon class="material-icons">add_circle</mat-icon></div>
              </div>
            </div>
            <app-button [type]="'submit'" [classCss]="''" [text]="'commons.add'"></app-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
